// extracted by mini-css-extract-plugin
module.exports = {"container":"AddMoreSection-module__container--1k0Jl","textArea":"AddMoreSection-module__textArea--OI5xV"};